/**
 * Created by jv on 14/06/2017.
 */
module.exports = {
  DEFAULT_LOCALE: "nl-BE",

  API_DATE_FORMAT: "YYYY-MM-DDTHH:mm:ss.SSSZZ",
  READABLE_DATE_FORMAT: "DD-MM-YYYY"
};



// WEBPACK FOOTER //
// ./app/js/config/constants.js